module.exports = __webpack_public_path__ + "static/media/karna_pearson.7250c9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_pearson.png
// module id = 397
// module chunks = 0